export default {
    'name': 'dragndrop',
    'width': '24',
    'height': '24',
    'viewBox': '0 0 24 24',
    'data': '<path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M16.9227 7.39628C17.1179 7.20102 17.1179 6.88443 16.9227 6.68917C16.7274 6.49391 16.4108 6.49391 16.2156 6.68917L6.68917 16.2156C6.49391 16.4108 6.49391 16.7274 6.68917 16.9227C6.88443 17.1179 7.20102 17.1179 7.39628 16.9227L16.9227 7.39628ZM18.6038 12.4397C18.799 12.2444 18.799 11.9278 18.6038 11.7326C18.4085 11.5373 18.0919 11.5373 17.8967 11.7326L11.7326 17.8967C11.5373 18.0919 11.5373 18.4085 11.7326 18.6038C11.9278 18.799 12.2444 18.799 12.4397 18.6038L18.6038 12.4397Z\' fill=\'#42A463\'/>'
}
